export const ACTION_COVER = 'action/upload-cover';
export const ACTION_CHAT = 'action/chat';
export const ACTION_EDIT = 'action/edit';
export const ACTION_EMPTY = 'action/empty';
export const ACTION_FILTER = 'action/filter';
export const ACTION_INFORMATION = 'action/information';
export const ACTION_LOCKED = 'action/lock-locked';
export const ACTION_UNLOCKED = 'action/lock-unlock';
export const ACTION_MENU = 'action/menu';
export const ACTION_MORE_V = 'action/more-vertical';
export const ACTION_MORE_H = 'action/more-horizontal';
export const ACTION_RELOAD = 'action/reload';
export const ACTION_SEARCH = 'action/search';
export const ACTION_SHARE = 'action/share';
export const ACTION_SYNC = 'action/sync';
export const ACTION_OPEN_IN_NEW = 'action/open-in-new';
export const ACTION_PHOTO = 'action/upload-photo';
export const ACTION_UPLOAD = 'action/upload-active';
export const ACTION_DOWNLOAD = 'action/download-active';
export const ACTION_VISIBILITY_ON = 'action/visibility-on';
export const ACTION_VISIBILITY_OFF = 'action/visibility-off';
export const ACTION_SORT = 'action/sort';
export const BAR_CART = 'bar/cart-active';
export const BAR_CART_OUTLINE = 'bar/cart-outline';
export const FACILITY_24_HOURS_SECURITY = 'facility/24-hours-security';
export const FACILITY_ATM_CENTER = 'facility/atm-center';
export const FACILITY_BBQ_AREA = 'facility/bbq-area';
export const FACILITY_CAFE = 'facility/cafe';
export const FACILITY_CHILDREN_PLAYGROUND = 'facility/kids-playground';
export const FACILITY_CLINIC = 'facility/clinic';
export const FACILITY_COWORKING_SPACE = 'facility/coworking-space';
export const FACILITY_DAY_CARE_CENTER = 'facility/daycare';
export const FACILITY_FREE_WIFI = 'facility/wifi';
export const FACILITY_GYM = 'facility/gym';
export const FACILITY_JACUZZI = 'facility/jacuzzi';
export const FACILITY_JOGGING_TRACK = 'facility/jogging-track';
export const FACILITY_LAUNDRY = 'facility/laundry';
export const FACILITY_LIBRARY = 'facility/library';
export const FACILITY_LOCKER = 'facility/locker';
export const FACILITY_LOUNGE = 'facility/lounge';
export const FACILITY_MAILBOX = 'facility/mailbox';
export const FACILITY_MALL = 'facility/mall';
export const FACILITY_MEETING_ROOM = 'facility/meeting-room';
export const FACILITY_MINIMARKET = 'facility/minimarket';
export const FACILITY_MULTI_FUNCTION_ROOM = 'facility/multi-function';
export const FACILITY_PARK = 'facility/park';
export const FACILITY_PRIVATE_LIFT = 'facility/private-lift';
export const FACILITY_RENTAL_MANAGEMENT_SERVICE = 'facility/rms';
export const FACILITY_ROOFTOP = 'facility/rooftop';
export const FACILITY_SPA = 'facility/spa';
export const FACILITY_SPORTS = 'facility/sport';
export const FACILITY_SUPERMARKET = 'facility/supermarket';
export const FACILITY_SWIMMING_POOL = 'facility/swimming-pool';
export const FACILITY_TRAIN_STATION = 'facility/stasiun-krl';
export const IMG_14_DAYS_RETURN_PRODUCT = 'image/14days-product';
export const IMG_14_DAYS_RETURN_MONEY = 'image/14days-money';
export const IMG_3D_ASSET_DYNAMIC = 'image/dynamic-3d';
export const IMG_3D_ASSET_MULTI_SKU = 'image/multi-sku-3d';
export const IMG_BATH_ROOM = 'image/kamar-mandi';
export const IMG_APARTMENT = 'image/apartment';
export const IMG_APARTMENT_OUTLINE = 'image/apartment-outline';
export const IMG_AREA = 'image/luas';
export const IMG_ATTACHMENT = 'image/attachment';
export const IMG_ATTENTION = 'image/attention';
export const IMG_BED_ROOM = 'image/kamar-tidur';
export const IMG_BELL_ALARM = 'image/bell-alarm';
export const IMG_BELL_FILLED = 'image/bell-filled';
export const IMG_BELL_OUTLINE = 'image/bell-outline';
export const IMG_CART = 'image/cart-active';
export const IMG_DATE_ACTIVE = 'image/date-active';
export const IMG_DATE_ADD = 'image/date-add';
export const IMG_DATE_APPROVE = 'image/date-approve';
export const IMG_DATE_CANCEL = 'image/date-cancel';
export const IMG_DISPOSE_MATTRESS = 'image/mattress-dispose';
export const IMG_DURATION = 'image/duration';
export const IMG_LOOSE = 'image/category-loose';
export const IMG_MODULAR = 'image/category-modular';
export const IMG_MONEY_BACK_GUARANTEE = 'image/money-back-guarantee';
export const IMG_MONEY_OFF = 'image/money-off';
export const IMG_HOUSE = 'image/house-active';
export const IMG_ID_CARD = 'image/idcard';
export const IMG_ID_CARD_SELFIE = 'image/idcard-selfie';
export const IMG_INSTALLMENT = 'image/installment';
export const IMG_INTERIOR = 'image/interior';
export const IMG_ITEM_COLOR = 'image/item-color';
export const IMG_ITEM_SUPPLY = 'image/item-supply';
export const IMG_LIST = 'image/list-active';
export const IMG_LOCATION = 'image/location';
export const IMG_MARKET = 'image/market';
export const IMG_MARKET_OUTLINE = 'image/market-outline';
export const IMG_NAVIGATION = 'image/navigation-top';
export const IMG_NOTES = 'image/notes';
export const IMG_PEOPLE = 'image/people';
export const IMG_PHOTO = 'image/photo';
export const IMG_PHOTO_EMPTY = 'image/photo-empty';
export const IMG_PRINT_ACTIVE = 'image/print-active';
export const IMG_PRODUCT_WARRANTY = 'image/product-warranty';
export const IMG_PROFILE_ROUND = 'image/profile-round';
export const IMG_PROFILE_SQUARE = 'image/profile-square';
export const IMG_PROMO_TAG = 'image/promo-tag';
export const IMG_SELECTED_PRODUCT = 'image/selected-product';
export const IMG_SERVICE = 'image/service';
export const IMG_SERVICE_OUTLINE = 'image/service-outline';
export const IMG_SHIPPING = 'image/shipping';
export const IMG_SOFA = 'image/sofa';
export const IMG_SOFA_OUTLINE = 'image/sofa-outline';
export const IMG_STOPWATCH = 'image/stopwatch';
export const IMG_TAGS_ACTIVE = 'image/tags-active';
export const IMG_TIME = 'image/time';
export const IMG_TOUCH = 'image/touch-active';
export const IMG_TRADE_IN = 'image/trade-in';
export const IMG_UNIT_TYPE = 'image/tipe-properti';
export const IMG_WARNING = 'image/warning';
export const IMG_WARRANTY = 'image/warranty';
export const NAV_ARROW_LEFT = 'navigation/arrow-left';
export const NAV_ARROW_BACK = 'navigation/arrow-back';
export const NAV_ARROW_BOTTOM = 'navigation/arrow-bottom';
export const NAV_ARROW_DOWN = 'navigation/arrow-down';
export const NAV_ARROW_NEXT = 'navigation/arrow-next';
export const NAV_ARROW_RIGHT = 'navigation/arrow-right';
export const NAV_ARROW_TOP = 'navigation/arrow-top';
export const NAV_ARROW_UP = 'navigation/arrow-up';
export const NAV_CHEVRON_LEFT = 'navigation/chevron-left';
export const NAV_CHEVRON_LESS = 'navigation/chevron-less';
export const NAV_CHEVRON_MORE = 'navigation/chevron-more';
export const NAV_CHEVRON_RIGHT = 'navigation/chevron-right';
export const NAV_CLOSE_ROUND = 'navigation/close-round';
export const NAV_CLOSE = 'navigation/close';
export const SOCIAL_FB_LOGO = 'social/facebook-logo';
export const SOCIAL_FB_LOGO_TOSCA = 'social/facebook-logo-tosca';
export const SOCIAL_IG_LOGO_TOSCA = 'social/instagram-logo-tosca';
export const SOCIAL_WA_LOGO = 'social/whatsapp-logo';
export const TOGGLE_BOX_ADD = 'toggle/box-add';
export const TOGGLE_BOX_MINUS = 'toggle/box-minus';
export const TOGGLE_CHECK_CIRCLE_OUTLINE = 'toggle/check_circle_outline';
export const TOGGLE_CHECK_OCTAGRAM_OUTLINE = 'toggle/check_octagram_outline';
export const TOGGLE_CHECKBOX_BLANK = 'toggle/checkbox-blank';
export const TOGGLE_CHECKBOX_FILLED = 'toggle/checkbox-filled';
export const TOGGLE_HEART_EMPTY = 'toggle/heart-empty';
export const TOGGLE_HEART_FULL = 'toggle/heart-full';
export const TOGGLE_LOVE_EMPTY = 'toggle/love-empty';
export const TOGGLE_LOVE_FULL = 'toggle/love-full';
export const TOGGLE_RADIO_CHECKED = 'toggle/radio-checked';
export const TOGGLE_RADIO_UNCHECKED = 'toggle/radio-unchecked';
export const TOGGLE_ROUND_ADD = 'toggle/round-add';
export const TOGGLE_ROUND_MINUS = 'toggle/round-minus';
export const TOGGLE_STAR_EMPTY = 'toggle/star-empty';
export const TOGGLE_STAR_FULL = 'toggle/star-full';
export const TOGGLE_STAR_HALF = 'toggle/star-half';
export const TOGGLE_SYMBOL_ADD = 'toggle/symbol-add';
export const TOGGLE_SYMBOL_CHECK = 'toggle/symbol-check';
export const TOGGLE_SYMBOL_MINUS = 'toggle/symbol-minus';
export const ICON_LIST = [/* ACTION */
ACTION_COVER, ACTION_CHAT, ACTION_DOWNLOAD, ACTION_EDIT, ACTION_EMPTY, ACTION_FILTER, ACTION_INFORMATION, ACTION_LOCKED, ACTION_MENU, ACTION_MORE_V, ACTION_MORE_H, ACTION_OPEN_IN_NEW, ACTION_PHOTO, ACTION_RELOAD, ACTION_SEARCH, ACTION_SHARE, ACTION_SYNC, ACTION_UNLOCKED, ACTION_UPLOAD, ACTION_VISIBILITY_ON, ACTION_VISIBILITY_OFF, /* BAR */
BAR_CART, BAR_CART_OUTLINE, /* FACILITY */
FACILITY_24_HOURS_SECURITY, FACILITY_ATM_CENTER, FACILITY_BBQ_AREA, FACILITY_CAFE, FACILITY_CHILDREN_PLAYGROUND, FACILITY_CLINIC, FACILITY_COWORKING_SPACE, FACILITY_DAY_CARE_CENTER, FACILITY_FREE_WIFI, FACILITY_GYM, FACILITY_JACUZZI, FACILITY_JOGGING_TRACK, FACILITY_LAUNDRY, FACILITY_LIBRARY, FACILITY_LOCKER, FACILITY_LOUNGE, FACILITY_MAILBOX, FACILITY_MALL, FACILITY_MEETING_ROOM, FACILITY_MINIMARKET, FACILITY_MULTI_FUNCTION_ROOM, FACILITY_PARK, FACILITY_PRIVATE_LIFT, FACILITY_RENTAL_MANAGEMENT_SERVICE, FACILITY_ROOFTOP, FACILITY_SPA, FACILITY_SPORTS, FACILITY_SUPERMARKET, FACILITY_SWIMMING_POOL, FACILITY_TRAIN_STATION, /* IMAGE */
IMG_14_DAYS_RETURN_PRODUCT, IMG_14_DAYS_RETURN_MONEY, IMG_3D_ASSET_DYNAMIC, IMG_3D_ASSET_MULTI_SKU, IMG_BATH_ROOM, IMG_APARTMENT, IMG_APARTMENT_OUTLINE, IMG_AREA, IMG_ATTACHMENT, IMG_ATTENTION, IMG_BED_ROOM, IMG_BELL_ALARM, IMG_BELL_FILLED, IMG_BELL_OUTLINE, IMG_CART, IMG_LOOSE, IMG_MODULAR, IMG_DATE_ACTIVE, IMG_DATE_ADD, IMG_DATE_APPROVE, IMG_DATE_CANCEL, IMG_DISPOSE_MATTRESS, IMG_DURATION, IMG_HOUSE, IMG_ID_CARD, IMG_ID_CARD_SELFIE, IMG_INSTALLMENT, IMG_INTERIOR, IMG_ITEM_COLOR, IMG_ITEM_SUPPLY, IMG_LIST, IMG_LOCATION, IMG_MARKET, IMG_MARKET_OUTLINE, IMG_MONEY_BACK_GUARANTEE, IMG_MONEY_OFF, IMG_NAVIGATION, IMG_NOTES, IMG_PEOPLE, IMG_PHOTO, IMG_PHOTO_EMPTY, IMG_PRINT_ACTIVE, IMG_PRODUCT_WARRANTY, IMG_PROFILE_ROUND, IMG_PROFILE_SQUARE, IMG_PROMO_TAG, IMG_SELECTED_PRODUCT, IMG_SERVICE, IMG_SERVICE_OUTLINE, IMG_SHIPPING, IMG_SOFA, IMG_SOFA_OUTLINE, IMG_STOPWATCH, IMG_TIME, IMG_TOUCH, IMG_TRADE_IN, IMG_UNIT_TYPE, IMG_WARNING, IMG_WARRANTY, /* NAVIGATION */
NAV_ARROW_LEFT, NAV_ARROW_BACK, NAV_ARROW_BOTTOM, NAV_ARROW_DOWN, NAV_ARROW_NEXT, NAV_ARROW_RIGHT, NAV_ARROW_TOP, NAV_ARROW_UP, NAV_CHEVRON_LEFT, NAV_CHEVRON_LESS, NAV_CHEVRON_MORE, NAV_CHEVRON_RIGHT, NAV_CLOSE_ROUND, NAV_CLOSE, /* SOCIAL */
SOCIAL_FB_LOGO, SOCIAL_FB_LOGO_TOSCA, SOCIAL_IG_LOGO_TOSCA, SOCIAL_WA_LOGO, /* TOGGLE */
TOGGLE_BOX_ADD, TOGGLE_BOX_MINUS, TOGGLE_CHECK_CIRCLE_OUTLINE, TOGGLE_CHECK_OCTAGRAM_OUTLINE, TOGGLE_CHECKBOX_BLANK, TOGGLE_CHECKBOX_FILLED, TOGGLE_HEART_EMPTY, TOGGLE_HEART_FULL, TOGGLE_LOVE_EMPTY, TOGGLE_LOVE_FULL, TOGGLE_RADIO_CHECKED, TOGGLE_RADIO_UNCHECKED, TOGGLE_ROUND_ADD, TOGGLE_ROUND_MINUS, TOGGLE_STAR_EMPTY, TOGGLE_STAR_FULL, TOGGLE_STAR_HALF, TOGGLE_SYMBOL_ADD, TOGGLE_SYMBOL_CHECK, TOGGLE_SYMBOL_MINUS];
export const BASE_URL_ICON = 'icon/v2/';